import { Socket } from 'socket.io-client';

import { emitSocketV2ResearchAssistantEvent } from '@verantos-dev/app-state-base';
import { ModelVersion } from '@verantos-dev/app-state-research-assistant';
import { transformUser } from '@verantos-dev/core-auth';
import { IVerantosUser } from '@verantos-dev/types-common';

export const emitUnsubscribeFromCohort = (
  projectId: string,
  cohortId: string,
  cohortVersionId: string | undefined,
  model: ModelVersion
) => {
  emitSocketV2ResearchAssistantEvent('unsubscribe', {
    message: 'clear',
    projectId,
    cohortId,
    cohortVersionId,
    model,
  });
};

export const emitSubscribeToCohort = (
  socket: Socket,
  projectId: string,
  cohortId: string,
  cohortVersionId: string | undefined,
  model: ModelVersion,
  isOwner: boolean,
  user: IVerantosUser
) => {
  socket.emit('subscribe', {
    model,
    data: {
      isOwner,
      cohortVersionId,
      cohortId,
      projectId,
      userInfo: transformUser(user),
    },
  });
};

export const emitResubscribeToCohort = (
  socket: Socket,
  projectId: string,
  cohortId: string,
  cohortVersionId: string | undefined,
  model: ModelVersion,
  user: IVerantosUser
) => {
  socket.emit('resubscribe', {
    model,
    data: {
      cohortVersionId,
      cohortId,
      projectId,
      userInfo: transformUser(user),
    },
  });
};
